import React from 'react';
import { Row } from 'reactstrap';

export const SinMaterias = () => {
    return (
        <Row style={{ flexDirection: 'column', with: '100vw', justifyContent: 'center', alignItems: 'center', margin: '0' }}>
            <img src="/Images/iconos/buscar@3x.png" alt="Buscar" style={{ width: '176px', height: '150px', marginTop: '100px' }} />
            <span style={{textAlign: 'center'}}>No cuentas con materias inscritas en este período.</span>
        </Row>
    )
}
